import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';

import { BrowserRouter } from 'react-router-dom';

const container = document.getElementById('root');
const app = (
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

// Пререндер (scripts/prerender.js) кладёт готовую разметку прямо в index.html —
// пользователь видит резюме сразу, до загрузки JS. Гидрировать её нельзя:
// DOM-снапшот схлопывает соседние текстовые узлы, которые React ждёт раздельными
// (hydration mismatch, React #418). Поэтому просто рендерим поверх — разметка
// идентична, замена происходит незаметно.
ReactDOM.createRoot(container).render(app);